// Todo - create functionality for language specific urls
export const MEMBERSHIP_PROGRAM_INFO = 'https://www.noddi.co/no/naf';
export const REFERRAL_PROGRAM_INFO = 'https://www.noddi.co/no/verving';
export const CUSTOMER_SERVICE_EMAIL = 'mailto:hei@noddi.no';
